/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TIsOperatorModel,
  IIsOperatorRequest,
  IMappers,
  IIsOperatorResponse,
  IIsOperatorResponseError,
  TIsOperatorResponse
} from "./types";

const defaultConfig: TIsOperatorModel = {
  apiType: "public",
  assertStatusCodes: [200, 400],
  method: "GET",
  microserviceName: "coworking",
  pathApi: "/v1/is-operator/",
  hostType: "api"
} as TIsOperatorModel;

function createIsOperatorModel(
  parameters: IIsOperatorRequest
): TIsOperatorModel {
  return {
    ...defaultConfig,
    parameters
  };
}

export interface IIsOperatorOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IIsOperatorRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchIsOperator<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers
}: IIsOperatorOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TIsOperatorResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createIsOperatorModel(parameters),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIsOperatorResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IIsOperatorResponseError);
    }
  }

  return { response, statusCode } as TIsOperatorResponse;
}

export { defaultConfig, createIsOperatorModel, fetchIsOperator };
